import { flushAnalyticsEventsOnUnload } from './service'

export const addAnalyticsEventListeners = () => {
  window.addEventListener('beforeunload', flushAnalyticsEventsOnUnload)
}

export const removeAnalyticsEventListeners = () => {
  window.removeEventListener('beforeunload', flushAnalyticsEventsOnUnload)
}
